import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ResolveEnd, ResolveStart, Router, RouterOutlet } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { ActivatedClientService } from '@vdms-hq/auth';
import { UILoaderModule } from '@vdms-hq/ui';
import { AsyncPipe } from '@angular/common';
import { MessagesComponent } from '@vdms-hq/toast';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, UILoaderModule, AsyncPipe, MessagesComponent],
  standalone: true,
})
export class AppComponent {
  private router: Router = inject(Router);
  public activatedClient: ActivatedClientService = inject(ActivatedClientService);
  isLoading$ = this.router.events.pipe(
    filter((event) => event instanceof ResolveStart || event instanceof ResolveEnd),
    map((event) => event instanceof ResolveStart),
  );
}
